(function () {

    'use strict';

    if (typeof window === 'undefined') {
        module.exports = definition(
            require('./metrics.js')
        );
    } else {
        RivalIQ.enums.email = definition(
            RivalIQ.enums
        );
    }

    function definition(enums) {
        const exports = {};

        const frequency = exports.frequency = {
            hour: 'As discovered',
            day: 'Once a day, at most',
            week: 'Weekly'
        };

        // Alert Generation Groups
        // alerts that are generated together. Used by emailServices to indicate which alerts to generate and send
        const group = exports.group = {
            // 1 is defunct
            socialSummary: 2,
            alerts: 3,
            // 4 is defunct
            facebookAds: 5,
            // 6 is defunct
            listening: 7
        };

        const groupDetails = exports.groupDetails = {};

        groupDetails[group.socialSummary] = {
            sourceMask: enums.sourceMask.CROSS_CHANNEL,
            defaultSchedule: {
                day: 5,
                hour: 14,
                period: 'week',
                followsTimezone: true
            }
        };
        groupDetails[group.alerts] = {
            sourceMask: enums.sourceMask.CROSS_CHANNEL
        };
        groupDetails[group.facebookAds] = {
            sourceMask: enums.sourceMask.FACEBOOK_ADS
        };
        groupDetails[group.listening] = {
            sourceMask: enums.sourceMask.CROSS_CHANNEL, // BUGBUG are we going to add a source for listening?
            period: 'day',
            defaultSchedule: {
                hour: 3,
                period: 'day',
                followsTimezone: true
            }
        };

        exports.schedulableGroups = [group.socialSummary];
        exports.otherGroups = [group.listening];
        exports.scheduledGroups = [].concat(exports.schedulableGroups, exports.otherGroups);

        // Alert Types
        // what we allow the user to configure
        // NOTE: these are similar to, but not identical to the eventClass and eventType in eventFeedServices.js
        // Someday we should resolve both and the alert sections into a single description hierarchy, but today is not that day.
        const type = exports.type = {
            // weekly / weekly updates
            socialSummary: 2,
            // 4 is defunct

            // daily / social
            landscapeBreakoutPost: 5,
            landscapePresenceChange: 8,
            likelyBoostedPost: 14,

            // as discovered / facebook ads
            facebookAdsUnderPerforming: 10,
            facebookAdsTopPerformer: 11,

            // the alerts formerly known as landscapeNotableMetricChange aka "big metric moves"
            engagementGrowth: 12,
            audienceGrowth: 13,

            // alerts formerly known as landscapeLanguageAndBioChange
            websiteLanguageChange: 18,
            socialChange: 19,
            instagramLinkedSiteChange: 20,

            // listening alerts
            listeningVolumeChanges: 21
        };


        exports.defaultSettings = {};
        exports.defaultSettings[type.socialSummary] = true;
        exports.defaultSettings[type.landscapeBreakoutPost] = true;
        exports.defaultSettings[type.engagementGrowth] = true;
        exports.defaultSettings[type.audienceGrowth] = true;
        exports.defaultSettings[type.likelyBoostedPost] = true;
        exports.defaultSettings[type.landscapePresenceChange] = true;
        exports.defaultSettings[type.facebookAdsUnderPerforming] = true;
        exports.defaultSettings[type.facebookAdsTopPerformer] = true;
        exports.defaultSettings[type.websiteLanguageChange] = true;
        exports.defaultSettings[type.socialChange] = true;
        exports.defaultSettings[type.instagramLinkedSiteChange] = true;
        exports.defaultSettings[type.listeningVolumeChanges] = true;

        // Alert Sections
        // how we organize the types in the UI
        const section = exports.section = {
            facebookAds: 'Facebook Ads Alerts',
            weeklyUpdates: 'Weekly Update Emails',
            social: 'Social Alerts',
            listening: 'Listening Alerts'
        };

        const details = exports.details = {};

        details[type.socialSummary] = {
            description: 'Social Summary',
            information: 'A checkup of your social media analytics along with some of the top performing posts of the week.',
            dashboardEmailTypeId: type.socialSummary,
            group: group.socialSummary,
            frequency: frequency.week,
            section: section.weeklyUpdates,
            sourceMask: enums.sourceMask.CROSS_CHANNEL
        };

        details[type.landscapeBreakoutPost] = {
            dashboardEmailTypeId: type.landscapeBreakoutPost,
            description: 'Breakout Posts',
            information: 'Receive an alert when we detect a post has earned engagement well above the average for that company.',
            group: group.alerts,
            frequency: frequency.day,
            section: section.social,
            sourceMask: enums.sourceMask.CROSS_CHANNEL
        };

        details[type.likelyBoostedPost] = {
            dashboardEmailTypeId: type.likelyBoostedPost,
            description: 'Notable Likely Boosted Posts',
            information: 'Receive an alert when we detect a likely boosted post with engagement well above the average among recently likely boosted posts from a company. A likely boosted post is a post whose engagement can likely be explained by a paid boost.',
            group: group.alerts,
            frequency: frequency.day,
            section: section.social,
            sourceMask: enums.sourceMask.FACEBOOK,
            conditionalDefault: true
        };

        details[type.engagementGrowth] = {
            dashboardEmailTypeId: type.engagementGrowth,
            description: 'Big Engagement Moves',
            information: 'Receive an alert when a company has dramatically moved their engagement during any 7 day period.',
            group: group.alerts,
            frequency: frequency.day,
            section: section.social,
            sourceMask: enums.sourceMask.CROSS_CHANNEL
        };

        details[type.audienceGrowth] = {
            dashboardEmailTypeId: type.audienceGrowth,
            description: 'Big Audience Moves',
            information: 'Receive an alert when a company has dramatically moved their followers during any 7 day period.',
            group: group.alerts,
            frequency: frequency.day,
            section: section.social,
            sourceMask: enums.sourceMask.CROSS_CHANNEL
        };

        details[type.landscapePresenceChange] = {
            dashboardEmailTypeId: type.landscapePresenceChange,
            description: 'Social Handle Changes',
            information: 'Receive an alert when a company has a new social handle, or a social handle that has been deactivated.',
            group: group.alerts,
            frequency: frequency.day,
            section: section.social,
            sourceMask: enums.sourceMask.CROSS_CHANNEL
        };

        details[type.facebookAdsUnderPerforming] = {
            dashboardEmailTypeId: type.facebookAdsUnderPerforming,
            description: 'Underperforming Group',
            information: 'Receive an alert when we detect poor performance on Cost Per Results for an ad set, age/gender breakdown, or placement breakdown.',
            group: group.facebookAds,
            frequency: frequency.day,
            section: section.facebookAds,
            sourceMask: enums.sourceMask.FACEBOOK_ADS
        };

        details[type.facebookAdsTopPerformer] = {
            dashboardEmailTypeId: type.facebookAdsTopPerformer,
            description: 'Top Performing Group',
            information: 'Receive an alert when we detect above average performance on Cost Per Results for an ad set, age/gender breakdown, or placement breakdown.',
            group: group.facebookAds,
            frequency: frequency.day,
            section: section.facebookAds,
            sourceMask: enums.sourceMask.FACEBOOK_ADS
        };

        details[type.websiteLanguageChange] = {
            dashboardEmailTypeId: type.websiteLanguageChange,
            description: 'Website Language Changes',
            information: 'Receive an alert when a company changes their website meta tags.',
            group: group.alerts,
            frequency: frequency.day,
            section: section.social,
            sourceMask: enums.sourceMask.CROSS_CHANNEL
        };

        details[type.socialChange] = {
            dashboardEmailTypeId: type.socialChange,
            description: 'Social Bio Changes',
            information: 'Receive an alert when a company changes their social media bios.',
            group: group.alerts,
            frequency: frequency.day,
            section: section.social,
            sourceMask: enums.sourceMask.CROSS_CHANNEL
        };

        details[type.instagramLinkedSiteChange] = {
            dashboardEmailTypeId: type.instagramLinkedSiteChange,
            description: 'Instagram Bio Link Changes',
            information: 'Receive an alert when a company changes their Instagram linked site.',
            group: group.alerts,
            frequency: frequency.day,
            section: section.social,
            sourceMask: enums.sourceMask.INSTAGRAM
        };

        details[type.listeningVolumeChanges] = {
            dashboardEmailTypeId: type.listeningVolumeChanges,
            description: 'Social Listening Post Volume Changes',
            information: 'Receive an alert when the post volume of a topic increases significantly.',
            group: group.listening,
            frequency: frequency.day,
            section: section.listening
        };

        return exports;
    }
})();
